import { catchError } from './Error.action'
import { 
    searchError,
    dispatchProductData,
    FACETED_SEARCH_LOADING, 
    FACETED_SEARCH_QUERY } 
from './FacetedSearch.action';

import { post, put } from '../Services/http';

export const COMPLETE_WHEELS_SET_CATEGORY = 'COMPLETE_WHEELS_SET_CATEGORY'; 
export const COMPLETE_WHEELS_SELECT_PRODUCT = 'COMPLETE_WHEELS_SELECT_PRODUCT'; 


export const updateCategory = (category) =>  ({
    type: COMPLETE_WHEELS_SET_CATEGORY,
    payload: {
        category
    }
})

export const selectProduct = (product, withHtml = true, redirectUrl=null) => dispatch => {
    dispatch({
        type: FACETED_SEARCH_LOADING,
        payload: {
            loading: true
        }
    })
    dispatch({
        type: FACETED_SEARCH_QUERY,
        payload: {
            query: "",
        },
    })

    const productsViewCachedId = new Date().getTime() + ''
    let url = "/api/completeWheels/SetSelectedProduct"
    if(!withHtml) url += "?withHtml=false"
    put(url, product)
        .then(res => res.json())
        .then(data => {
            if(withHtml)
                dispatch(dispatchProductData(data, productsViewCachedId, true, "TireCategory"))
        })
        .catch((ex) => dispatch(catchError(ex, (error) => searchError(error))))
        .finally(() => {
            dispatch({
                type: FACETED_SEARCH_LOADING,
                payload: {
                    loading: false
                }
            })
            if(redirectUrl)
                window.location.href = redirectUrl
        })
}

export const updateSelectedProduct = (productCategory) => (dispatch) => {
    dispatch({
        type: FACETED_SEARCH_LOADING,
        payload: {
            loading: true
        }
    })

    const productsViewCachedId = new Date().getTime() + ''
    put(`/api/completeWheels/UpdateSelectedProduct/${productCategory}`)
        .then(res => res.json())
        .then(data => {
            dispatch(dispatchProductData(data, productsViewCachedId, true, productCategory))
        })
        .catch((ex) => dispatch(catchError(ex, (error) => searchError(error))))
        .finally(() => {
            dispatch({
                type: FACETED_SEARCH_LOADING,
                payload: {
                    loading: false
                }
            })
        })
}